<template>
    <div>
        <div class="online">
            <p v-show="showTop" class="up onlineBorder" @click="handelTop"><img src="../assets/common/ic_right.png" /></p>
            <div class="onlineBorder" @click="handelShow">
                <p class="serve"><img src="../assets/common/serve1.png" /></p>
                <p>产品<br />报价</p>
            </div>
            <div class="onlineBorder" @click="handelShow">
                <p class="serve"><img src="../assets/common/serve2.png" /></p>
                <p>合作<br />申请</p>
            </div>
            <div class="onlineBorder" @click="handelShow">
                <p class="serve"><img src="../assets/common/serve3.png" /></p>
                <p>体验<br />账号</p>
            </div>
            <!-- <div class="onlineBorder" @click="handelMall">
                <p class="serve"><img src="../assets/common/mall.png" /></p>
                <p>心泰<br />商城</p>
            </div> -->
        </div>
        <div class="pop_window" v-show="show">
            <div class="pop_content">
                <p class="closePop" @click="handelShow"><img src="../assets/common/close.png"></p>
                <p style="display: none" class="titlePop">联系合作</p>
                <div style="display: none" class="itemGroup">
                    <div class="itemCase">
                        <div><img src="../assets/common/online1.png" /><span>
                                <h5>智能手表报价表</h5>申请智能手表报价表、健康合作
                            </span></div>
                        <div class="link_btn" @click="handelShow">立即申请</div>
                    </div>
                    <div class="itemCase">
                        <div><img src="../assets/common/online2.png" /><span>
                                <h5>免费申请APP</h5>免费申请app、系统体验账号、API文档
                            </span>
                        </div>
                        <div class="link_btn" @click="handelShow">免费申请</div>
                    </div>
                    <div class="itemCase">
                        <div><img src="../assets/common/online3.png" /><span>
                                <h5>产品合作</h5>平台运营、产品销售合作
                            </span></div>
                        <div class="link_btn" @click="handelShow">合作申请</div>
                    </div>
                </div>
                <div class="itemFlex">
                    <div class="itemFlex1">
                        <p class="titlePop">官方电话</p>
                        <p>173-7675-1232</p>
                        <p class="titlePop">官方邮箱</p>
                        <p>business@colofoo.com</p>
                        <p class="titlePop">关注我们</p>
                        <p class="imgPop">
                            <span><img src="../assets/common/xintai.png"><br />扫码关注我们</span>
                            <span><img src="../assets/common/yuncode.png"><br />商务洽谈</span>
                        </p>
                    </div>
                    <div class="itemFlex1">
                        <p class="titlePop">信息填写</p>
                        <div class="pop_sub">
                            您的姓名 <input ref="userNameID" v-model="userName" placeholder="联系人姓名" autofocus="autofocus">
                        </div>
                        <div class="pop_sub">
                            联系方式<input ref="phoneID" v-model="phone" placeholder="手机号码" type="number" autofocus="autofocus"
                                oninput="if(value.length>11) value=value.slice(0,11)">
                        </div>
                        <div class="pop_sub">
                            您的需求<textarea ref="contentID" v-model="content" placeholder="请写明您的具体需求，以便我们安排相应顾问与您联系：（选填）"
                                autofocus="autofocus" rows="4" maxlength="500"></textarea>
                        </div>
                    </div>
                </div>
                <div class="pop_submit" @click="closeConcat()" v-if="!isSub">提交</div>
                <div class="pop_submitS" v-if="isSub">提交成功，我们将尽快安排与您联系。</div>

            </div>
        </div>

        <div class="rightFiexd">
            <div class="closeVideo" @click="showVideo=false">x</div>
            <video poster="https://colofoo.com/video/videoBg.jpg" v-if="showVideo" src="https://colofoo.com/video/video.mp4"
                controls autoplay="autoplay" muted="muted"></video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'online',
    props: {
        showConnection: [Boolean]
    },
    data() {
        return {
            showVideo: true,
            isSub: false,
            show: false,
            showTop: false,
            userName: '',
            phone: '',
            content: '',
        }
    },
    watch: {
        showConnection() {
            this.show = this.showConnection;
        }
    },
    mounted() {
        // 监听页面滚动事件
        window.addEventListener("scroll", this.scrolling);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.scrolling);
    },
    methods: {
        handelMall() {
            window.open('https://shop118412868.m.youzan.com/v2/showcase/homepage?kdt_id=118220700&scan=3&from=kdt&shopAutoEnter=1')
        },
        handelShow() {
            this.show = !this.show;
						this.$emit('close',true)
        },
        scrolling() {
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            // 滚动条滚动的距离
            // let scrollStep = scrollTop - this.oldScrollTop;
            // console.log("header 滚动距离 ", scrollTop);
            // 更新——滚动前，滚动条距文档顶部的距离
            // this.oldScrollTop = scrollTop;
            if (scrollTop > 100) {
                this.showTop = true;
            } else {
                this.showTop = false;
            }
            // //变量windowHeight是可视区的高度
            // let windowHeight =
            //     document.documentElement.clientHeight || document.body.clientHeight;
            // //变量scrollHeight是滚动条的总高度
            // let scrollHeight =
            //     document.documentElement.scrollHeight || document.body.scrollHeight;
            //
            // //滚动条到底部的条件
            // if (scrollTop + windowHeight == scrollHeight) {
            //     //你想做的事情
            //     console.log("header  你已经到底部了");
            // }
            // if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            // } else {
            //     console.log("header  滚动条向下滚动了！");
            // }
            // // 判断是否到了最顶部
            // if (scrollTop <= 0) {
            //     console.log("header 到了最顶部")
            // }
        },
        handelTop() {
            window.scrollTo(0, 0);
            window.sessionStorage.setItem('fixed', false)
            let el = document.getElementsByClassName('probootstrap-navbar')[0];
            let navName = document.getElementsByClassName('navName')[0]
            let navName1 = document.getElementsByClassName('navName')[1]
            let navName2 = document.getElementsByClassName('navName')[2]
            let navName3 = document.getElementsByClassName('navName')[3]
            let navName4 = document.getElementsByClassName('navName')[4]
            el.style.background = 'transparent';
            navName.style.color = 'rgba(255, 255, 255, 0.7)'
            navName1.style.color = 'rgba(255, 255, 255, 0.7)';
            navName2.style.color = 'rgba(255, 255, 255, 0.7)';
            navName3.style.color = 'rgba(255, 255, 255, 0.7)';
            navName4.style.color = 'rgba(255, 255, 255, 0.7)';
        },
        // 校验手机号
        checkPhone(str) {
            const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            return reg.test(str)
        },
        closeConcat() {
            var _this = this;
            let userName = this.userName;
            let phone = this.phone;
            if (userName == '') {
                this.$refs.userNameID.style.borderColor = 'red';
                return;
            } else {
                this.$refs.userNameID.style.borderColor = '#ffffff';
            }
            let checked = this.checkPhone(phone);
            if (!checked) {
                this.$refs.phoneID.style.borderColor = 'red';
                return
            } else {
                this.$refs.phoneID.style.borderColor = '#ffffff';
            }
            let data = {
                phone: this.phone,
                userName: this.userName,
                companyName: "",
                content: this.content + '心奓体泰官网：' + location.href,
                position: "",
            };
            let url = 'https://api-xintai.colofoo.com/admin/contact/add';
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.setRequestHeader("decrypt", "0");
            xhr.setRequestHeader("lang", "ZH");
            xhr.setRequestHeader("country", "CN");
            xhr.setRequestHeader("token", "");
            xhr.send(JSON.stringify(data));
            _this.isSub = true;
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    setTimeout(() => {
                        _this.show = false;
                        _this.isSub = false;
                    }, 5000)
                    //判断响应状态码 200  404  403 401 500
                    // if (xhr.status >= 200 && xhr.status < 300) {
                    // 处理结果 行 头 空行 体
                    // 响应
                    // console.log('状态码', xhr.status); // 状态码
                    // console.log('状态字符串', xhr.statusText); // 状态字符串
                    // console.log('所有响应头', xhr.getAllResponseHeaders()); // 所有响应头
                    // console.log('响应体', xhr.response); // 响应体
                }
            }
        },
    }
}
</script>

<style scoped>
.rightFiexd {
    position: fixed;
    bottom: 10%;
    left: 0;
    z-index: 100;
}

.closeVideo {
    cursor: pointer;
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    width: 22px;
    height: 22px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid rgba(120, 132, 142, 1);
}

video {
    width: 280px;
    max-height: 280px;
}

.itemFlex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.itemFlex1 {
    width: 50%;
}

.itemFlex1 .pop_sub {
    margin-bottom: 20px;
}

.itemCase {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 0;
    width: 100%;
}

.itemCase h5 {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
    margin: 0;
}

.itemCase div:nth-child(1) {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
}

.itemCase img {
    height: 62px;
    margin-right: 20px;
}

.pop_window {
    z-index: 999999;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    display: flex;
    align-items: center;
    justify-content: center;
}

.pop_content {
    width: 860px;
    background: #FFFFFF;
    box-shadow: 0px 0px 29px 0px rgba(120, 132, 142, 0.5);
    border-radius: 4px;
    padding: 20px 58px 20px 38px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}

.onlinePop {
    z-index: 100;
    position: fixed;
    bottom: 6%;
    right: 100px;
    background: #FFFFFF;
    box-shadow: 0px 0px 29px 0px rgba(120, 132, 142, 0.5);
    border-radius: 6px;
    padding: 20px 58px 20px 38px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}

.closePop {
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
}

.titlePop {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 33px;
    position: relative;
}

.titlePop:after {
    content: '';
    width: 6px;
    height: 23px;
    background: #005EF0;
    border-radius: 5px;
    position: absolute;
    left: -10px;
    bottom: 2px;
    z-index: 0;
}

.titlePop:last-child {
    margin-top: 0;
}

.imgPop {
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #010101;
    line-height: 20px;
}

.pop_sub {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 44px;
}

.pop_sub input {
    width: 80%;
    margin-left: 10px;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    padding: 10px;
    outline: none;
    color: #000;
    background: #F3F5FA;
    border-radius: 6px;
    -webkit-box-shadow: 0 0 0 0px #ffffff inset;
    border-color: transparent;
}

.pop_sub textarea {
    width: 80%;
    margin-left: 10px;
    height: 200px;
    line-height: 22px;
    font-size: 16px;
    padding: 10px;
    outline: none;
    color: #000;
    background: #F3F5FA;
    border-radius: 6px;
    -webkit-box-shadow: 0 0 0 0px #ffffff inset;
    border-color: transparent;
}

input[type=number],
textarea {
    -moz-appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.pop_submit,
.pop_submitS {
    width: 100%;
    height: 44px;
    line-height: 44px;
    background: #00a6f2;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    border-radius: 20px;
    cursor: pointer;
}

.online {
    position: fixed;
    bottom: 10%;
    right: 0;
    width: 60px;
    background: #FFFFFF;
    box-shadow: 0px 0px 29px 0px rgba(120, 132, 142, 0.5);
    text-align: center;
    z-index: 99;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 25px;
    cursor: pointer;
}

.up {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid rgba(204, 204, 204, .6);
}

.up img {
    height: 34px;
    transform: rotate(-90deg);
}

.onlineBorder {
    padding: 10px 0;
    border-bottom: 1px solid rgba(204, 204, 204, .51);
}

.onlineBorder:nth-child(1) {
    padding: 0;
}

.onlineBorder p {
    margin: 0;
}

.serve img {
    height: 50px;
}</style>
